export default {
  en: {
    all:'All',
    aproved:'Aproved',
    available:'Available',
    comment:'comment',
    document:'document',
    expenses:'Expenses',
    end_date:'end date',
    folio:'Folio',
    frequency:'frequency',
    logout:'Logout',
    invoiced:'Invoiced',
    in_compliance:'In Compliance',
    in_review:'In Review',
    method:'Method',
    MenItem:'Main Item',
    no_data_available:'No data Available',
    paid:'Paid',
    pay_day:'Pay Day',
    pending:'Pending',
    policy:'Policy',
    received:'Received',
    received_date:'Received Date',
    reference:'Reference',
    rejected:'Rejected',
    requested: 'Requested',
    request_date:'request date',
    save:'save',
    serie:'Serie',
    status:'Status',
    search:'Search',
    start_date:'start date',
    transfer:'Transfer',
    upload_files:'upload files'
  },
  es:{
    all:'Todos',
    aproved:'Aprobados',
    available:'Disponible',
    check:'Cheque',
    comment:'Comentario',
    company:'Compañia',
    currency:'Moneda',
    document:'documento',
    expenses:'Facturas',
    end_date:'fecha de vencimiento',
    folio:'Folio',
    frequency:'frecuencia',
    logout:'Cerrar Sesión',
    invoiced:'Por Pagar',
    in_compliance:'En cumplimiento',
    in_review:'En revisión',
    method:'Método',
    MenItem:'Main Item',
    no_data_available:'Sin Información',
    paid:'Pagados',
    pay_day:'F. Est. Pago',
    pending:'Pendiente',
    policy:'Póliza',
    received:'Recibidos',
    received_date:'F. Recepción',
    rejected:'Rechazados',
    reference:'Referencia',
    requested: 'Solicitado',
    request_date:'fecha de solicitud',
    save:'guardar',
    serie:'Serie',
    status:'Estatus',
    search:'Buscar',
    start_date:'fecha de inicio',
    transfer:'Transferencia',
    upload_files:'Subir Arcivos'
    
  }
}
